import { Grid, Typography, TextField, Button, MenuItem, Link } from '@mui/material';
import React from 'react'
import colors from '../../../../colors';
import { useSelector, useDispatch } from 'react-redux';
import { sendGeneralRequest } from '../../../../../features/generalRequest'
import { makeStyles } from '@mui/styles';
import { selectUserInfo } from '../../../../../features/userInfo/userInfoSlice';
import { selectDigitalbState } from '../../../../../features/digitalb/digitalbSlice';
import { selectMyContractsState, setShouldFillFields } from '../../../../../features/myContracts/myContractsSlice';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { texts } from '../../../../general/texts';

export const Digitalb = (props) => {
    
    const dispatch = useDispatch()
    const userInfo = useSelector(selectUserInfo)
    const digitalbSliceState = useSelector(selectDigitalbState) 
    const myContractsSliceState = useSelector(selectMyContractsState)
    const navigate = useNavigate()

    const [state, setState] = React.useState({
        token: props.globalDataSliceState.token,
        productCode: '',
        phone: '',
        sc:''
    })

    const handleTextFieldChange = (prop) => (e) =>
    {
        setState({
            ...state,
            [prop]: e.target.value
        })
    }

    React.useEffect(()=>{
        dispatch(sendGeneralRequest({request: {token: state.token}, baseUrlKey:'services', endpoint:'DGA/GetProducts'}))       
    },[])

    React.useEffect(()=>{
        if(myContractsSliceState.shouldFillFields)
        {
            setState({
                ...state,
                sc: props.selectedContractInfo.contract
            })
            dispatch(setShouldFillFields(false))
        }
    },[myContractsSliceState.shouldFillFields])

    const useStyles = makeStyles({
        mainGrid:{
            padding: '5%',
            paddingTop: '3%'
        },
        utilityName:{
            color:props.utilityInfo.Color,
            fontSize:'1.5rem',
            fontFamily:'GerberaBold',
            paddingTop:'3%',
            paddingLeft:'2%'
        },
        headerBox:{
            backgroundColor:colors.cyan,
            borderRadius:'100%',
            width:'70px',
            height:'70px'
        },
        fieldTitle:{
            color:colors.darkBlue,
            fontSize:'1.2rem',
            fontFamily:'GerberaBold',
            textAlign:'left'
        },
        button:{
            width:'100%',
            color:colors.white,
            fontSize:'1rem',
            textTransform:'none',
            background:colors.gradientOrange,
            fontFamily:'GerberaBold'
        },
        buttonGrid:{
            marginTop: 15,
            paddingBottom: 5
        },
        image:{
            width:'50%'
        },
        textField:{
            width:'100%'
        }
    })

  const classes = useStyles()

  return (
    <Grid container item className={classes.mainGrid} rowSpacing={3} >
        <Grid container item md={2} xs={2} mt={2} ><Link component={'button'} onClick={()=> { navigate(-1)}}><ArrowBackIosNewIcon color='warning' /></Link></Grid>
        <Grid container item md={12} xs={12}  >
            <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.headerBox} ><img src={props.utilityInfo.Images.filter(image => image.color === 1 && image.size === 1)[0].imagePath} className={classes.image}/></Grid>
            <Typography className={classes.utilityName} >{props.utilityInfo.PublicName}</Typography>
        </Grid>
        <Grid container item md={12} xs={12} mt={'5%'} >
            <Typography className={classes.fieldTitle} >{texts["prompt-choose-product"]}</Typography>
        </Grid>
        <Grid item md={12} xs={12} >
            <TextField value={state.productCode} label={texts["dialog-product"]} select color='warning' size='small' onChange={handleTextFieldChange('productCode')} className={classes.textField}>
                {props.digitalbSliceState.extraData.map((option) => (
                    <MenuItem key={option.code} value={option.code}>
                        {option.name} {option.price + ' '+'Lek'}
                    </MenuItem>
                ))}   
            </TextField>
        </Grid>
        <Grid item md={12} xs={12} >
            <Typography className={classes.fieldTitle}>{texts["dialog-smartcard"]}</Typography>
        </Grid>
        <Grid item md={12} xs={12} >
            <TextField onChange={handleTextFieldChange('sc')} value={state.sc} color='warning' size='small' label={texts["placeholder-smartcard"]}className={classes.textField} />
        </Grid>
        <Grid item md={12} xs={12} >
            <Typography className={classes.fieldTitle}>{texts["dialog-phone"]}</Typography>
        </Grid>
        <Grid item md={12} xs={12} >
            <TextField onChange={handleTextFieldChange('phone')}  color='warning' size='small' label={'6########'} className={classes.textField} />
        </Grid>
        <Grid item md={12} xs={12} className={classes.buttonGrid}  >
            <Button disabled={digitalbSliceState.isLoading ? true : false || (!state.productCode || !state.phone || !state.sc)} onClick={()=> dispatch(sendGeneralRequest({request: state, baseUrlKey:'services', endpoint:'DGA/StartTransaction'}))} className={classes.button} >{texts["title-search"]}</Button>
        </Grid>
    </Grid>
  )
}
export default Digitalb